import styles from './DrawerToggler.module.scss';
import { useDispatch } from 'react-redux';
import { MenuOutlined } from '@ant-design/icons';
import { changeDrawerVisibility } from '../../../../redux/actions/sider-menu';

const DrawerToggler = () => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(changeDrawerVisibility(true));
    };

    return <MenuOutlined className={styles.toggler} onClick={onClick} />;
};

export default DrawerToggler;
